import { app } from '../../../../app';
import { Controller } from './share-public-user-account.controller';

app.component('sharePublicUserAccounts', {
    bindings: {
        account: '<',
        passwordManagers: '<',
        authenticators: '<',
		companies: '<'
    },
    controller: Controller,
    templateUrl: require('./share-public-user-account.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/share-public-user-account/share-public-user-account.component.js